module.exports = __webpack_public_path__ + "static/img/close_guide.f33f0b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/close_guide.png
// module id = TzA9
// module chunks = 1